"use strict";
// automatically generated by the FlatBuffers compiler, do not modify
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrackerIdT = exports.TrackerId = void 0;
const flatbuffers = __importStar(require("flatbuffers"));
const device_id_js_1 = require("../../solarxr-protocol/datatypes/device-id.js");
class TrackerId {
    constructor() {
        this.bb = null;
        this.bb_pos = 0;
    }
    __init(i, bb) {
        this.bb_pos = i;
        this.bb = bb;
        return this;
    }
    static getRootAsTrackerId(bb, obj) {
        return (obj || new TrackerId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    static getSizePrefixedRootAsTrackerId(bb, obj) {
        bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
        return (obj || new TrackerId()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
    }
    /**
     * The device the tracker is associated with. If there is no hardware device it is
     * associated with, this should be `null`.
     */
    deviceId(obj) {
        const offset = this.bb.__offset(this.bb_pos, 4);
        return offset ? (obj || new device_id_js_1.DeviceId()).__init(this.bb_pos + offset, this.bb) : null;
    }
    /**
     * There are possibly multiple trackers per device. This identifies which one.
     */
    trackerNum() {
        const offset = this.bb.__offset(this.bb_pos, 6);
        return offset ? this.bb.readUint8(this.bb_pos + offset) : 0;
    }
    static startTrackerId(builder) {
        builder.startObject(2);
    }
    static addDeviceId(builder, deviceIdOffset) {
        builder.addFieldStruct(0, deviceIdOffset, 0);
    }
    static addTrackerNum(builder, trackerNum) {
        builder.addFieldInt8(1, trackerNum, 0);
    }
    static endTrackerId(builder) {
        const offset = builder.endObject();
        return offset;
    }
    static createTrackerId(builder, deviceIdOffset, trackerNum) {
        TrackerId.startTrackerId(builder);
        TrackerId.addDeviceId(builder, deviceIdOffset);
        TrackerId.addTrackerNum(builder, trackerNum);
        return TrackerId.endTrackerId(builder);
    }
    unpack() {
        return new TrackerIdT((this.deviceId() !== null ? this.deviceId().unpack() : null), this.trackerNum());
    }
    unpackTo(_o) {
        _o.deviceId = (this.deviceId() !== null ? this.deviceId().unpack() : null);
        _o.trackerNum = this.trackerNum();
    }
}
exports.TrackerId = TrackerId;
class TrackerIdT {
    constructor(deviceId = null, trackerNum = 0) {
        this.deviceId = deviceId;
        this.trackerNum = trackerNum;
    }
    pack(builder) {
        return TrackerId.createTrackerId(builder, (this.deviceId !== null ? this.deviceId.pack(builder) : 0), this.trackerNum);
    }
}
exports.TrackerIdT = TrackerIdT;
